const globalCache: Record<string, string> = {};

export default globalCache;
